"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.ListField = exports.Loading = exports.Errors = exports.DeleteButton = exports.AddButton = exports.DiscardButton = exports.SubmitButton = exports.FirebaseFileInput = exports.ToggleField = exports.MultiCheckBoxField = exports.CheckBoxField = exports.MultiSelect = exports.AutoSuggestObject = exports.AutoSuggest = exports.MultiAutoSuggest = exports.HtmlField = exports.ComboField = exports.SelectObjectField = exports.SelectField = exports.RadioObjectField = exports.RadioField = exports.DateTimeField = exports.TimePicker = exports.DateField = exports.JsonKV = exports.InputField = exports.isnotnull = void 0;

var _entries = require("babel-runtime/core-js/object/entries"),
    _entries2 = _interopRequireDefault(_entries),
    _typeof2 = require("babel-runtime/helpers/typeof"),
    _typeof3 = _interopRequireDefault(_typeof2),
    _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray"),
    _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2),
    _slicedToArray2 = require("babel-runtime/helpers/slicedToArray"),
    _slicedToArray3 = _interopRequireDefault(_slicedToArray2),
    _extends2 = require("babel-runtime/helpers/extends"),
    _extends3 = _interopRequireDefault(_extends2),
    _stringify = require("babel-runtime/core-js/json/stringify"),
    _stringify2 = _interopRequireDefault(_stringify);

exports.fieldSwitcher = fieldSwitcher;

var _react = require("react"),
    _react2 = _interopRequireDefault(_react),
    _formatting = require("../formatting"),
    _DatePicker = require("office-ui-fabric-react/lib/DatePicker"),
    _TextField = require("office-ui-fabric-react/lib/TextField"),
    _ChoiceGroup = require("office-ui-fabric-react/lib/ChoiceGroup"),
    _Dropdown = require("office-ui-fabric-react/lib/Dropdown"),
    _ComboBox = require("office-ui-fabric-react/lib/ComboBox"),
    _Checkbox = require("office-ui-fabric-react/lib/Checkbox"),
    _Toggle = require("office-ui-fabric-react/lib/Toggle"),
    _Button = require("office-ui-fabric-react/lib/Button"),
    _Spinner = require("office-ui-fabric-react/lib/Spinner"),
    _MessageBar = require("office-ui-fabric-react/lib/MessageBar"),
    _Pickers = require("office-ui-fabric-react/lib/Pickers"),
    _fileinput = require("./fileinput"),
    _get = require("lodash/get"),
    _get2 = _interopRequireDefault(_get),
    _has = require("lodash/has"),
    _has2 = _interopRequireDefault(_has),
    _keyBy = require("lodash/keyBy"),
    _keyBy2 = _interopRequireDefault(_keyBy),
    _set = require("lodash/set"),
    _set2 = _interopRequireDefault(_set),
    _Stack = require("office-ui-fabric-react/lib/Stack"),
    _Label = require("office-ui-fabric-react/lib/Label"),
    _ = require("."),
    _2 = _interopRequireDefault(_),
    _RichEditor = require("./RichEditor"),
    _validations = require("../validations"),
    _Text = require("office-ui-fabric-react/lib/Text"),
    _Link = require("office-ui-fabric-react/lib/Link"),
    _Icon = require("office-ui-fabric-react/lib/Icon"),
    _Modal = require("office-ui-fabric-react/lib/Modal"),
    _reactHooks = require("@uifabric/react-hooks"),
    _Image = require("office-ui-fabric-react/lib/Image"),
    _uniqueId = require("lodash/uniqueId"),
    _uniqueId2 = _interopRequireDefault(_uniqueId);

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

var DayPickerStrings = {
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["S", "M", "T", "W", "T", "F", "S"],
  goToToday: "Go to today",
  prevMonthAriaLabel: "Go to previous month",
  nextMonthAriaLabel: "Go to next month",
  prevYearAriaLabel: "Go to previous year",
  nextYearAriaLabel: "Go to next year",
  closeButtonAriaLabel: "Close date picker"
},
    descStyle = {
  marginTop: "3px",
  color: "rgba(163, 162, 160)",
  fontSize: "10px"
},
    isnotnull = exports.isnotnull = function (a) {
  return "" !== a && null !== a && a !== void 0;
},
    inputFormat = function inputFormat(a, b) {
  return "titlecase" === a ? (0, _formatting.doFormatTitle)(b) : "upper" === a ? b.toUpperCase() : "lower" === a ? b.toLowerCase() : "slug" === a ? b.toLowerCase().replace(/[^a-z0-9-]/g, "") : "email" === a ? b.toLowerCase().trim().replace(" ", "") : "abhyasiid" === a ? b.toUpperCase().replace(/[^A-Za-z0-9]/g, "") : "pnr" === a ? b.toUpperCase().replace(/[^A-Za-z0-9-]/g, "") : b;
},
    validateJson = function validateJson(a) {
  if (!a) return "";

  try {
    return JSON.parse(a), "";
  } catch (a) {
    return "Invalid Json";
  }
},
    validateText = function validateText() {
  return "";
},
    InputField = exports.InputField = _react2.default.memo(function (a) {
  var b = (0, _react.useCallback)(function (b) {
    var c = b.target.value;
    return "number" === a.type ? void a.onFieldChange(parseInt(c)) : ((0, _has2.default)(a, "props.transform") && (c = inputFormat(a.props.transform, c)), void ("jsonfield" !== a.type && a.onFieldChange(c)));
  }, [a.type]),
      c = (0, _react.useCallback)(function (b) {
    var c = b.target.value;

    if ("jsonfield" === a.type) {
      var d = validateJson(c);

      if ("" === d) {
        try {
          c = JSON.parse(c);
        } catch (a) {}

        a.onFieldChange(c);
      }
    }
  }, [a.type]),
      d = {};

  if ("jsonfield" === a.type) {
    try {
      d.defaultValue = a.value ? (0, _stringify2.default)(a.value) : "";
    } catch (a) {
      d.defaultValue = "";
    }

    d.onBlur = c, d.onGetErrorMessage = validateJson, d.deferredValidationTime = 1e3;
  } else d.value = a.value;

  return _react2.default.createElement("div", null, _react2.default.createElement(_TextField.TextField, (0, _extends3.default)({
    key: "g" + a.name.toString(),
    required: !0
  }, a.props, {
    label: a.label,
    type: a.type,
    name: a.name.toString()
  }, d, {
    onChange: b
  })));
}),
    JsonKV = exports.JsonKV = _react2.default.memo(function (a) {
  var b = a.props,
      c = b.formfields,
      d = b.validator,
      e = b.defaults,
      f = b.readOnly,
      g = (0, _reactHooks.useBoolean)(!1),
      h = (0, _slicedToArray3.default)(g, 2),
      i = h[0],
      j = h[1],
      k = j.setTrue,
      l = j.setFalse,
      m = (0, _react.useCallback)(function (b, c) {
    return a.onFieldChange(b), c(), void l();
  }, []);
  return _react2.default.createElement("div", {
    style: (0, _get2.default)(a, ["props", "styles", "root"]),
    key: "g" + a.name.toString()
  }, !!a.label && _react2.default.createElement(_Label.Label, null, a.label, " ", (0, _get2.default)(a, ["props", "required"]) && "*"), _react2.default.createElement(_Button.DefaultButton, {
    text: "View / Set",
    onClick: k
  }), _react2.default.createElement(_Modal.Modal, {
    isOpen: i,
    isBlocking: !0,
    styles: {
      main: {
        backgroundColor: "#edebe9"
      },
      scrollableContent: {
        padding: 12
      },
      overlay: {
        backgroundColor: "rgba(0,0,0, 0.7)"
      }
    }
  }, _react2.default.createElement(_2.default, {
    formTitle: "Options for " + a.label,
    formFields: c,
    formValidator: d,
    defaultValues: (0, _extends3.default)({}, e, !a.value ? {} : a.value),
    onSubmit: m,
    onDiscard: l,
    hideSubmit: f !== void 0 && f
  })), (0, _has2.default)(a, ["props", "description"]) && _react2.default.createElement("div", {
    style: descStyle
  }, a.props.description));
}),
    DateField = exports.DateField = _react2.default.memo(function (a) {
  return (0, _has2.default)(a, ["props", "description"]) && (0, _set2.default)(a.props, ["textField", "description"], a.props.description), _react2.default.createElement(_DatePicker.DatePicker, (0, _extends3.default)({
    key: "g" + a.name.toString(),
    strings: DayPickerStrings,
    isRequired: !("required" in a.props) || (0, _get2.default)(a, ["props", "required"])
  }, a.props, {
    label: a.label,
    name: a.name,
    value: a.value ? (0, _formatting.formatOdooDate2Sys)(a.value) : "",
    onSelectDate: function c(b) {
      return a.onFieldChange((0, _formatting.formatSys2OdooDate)(b));
    }
  }, (0, _has2.default)(a, ["props", "pastDatesOnly"]) ? {
    maxDate: new Date()
  } : {}, (0, _has2.default)(a, ["props", "futureDatesOnly"]) ? {
    minDate: new Date()
  } : {}, (0, _has2.default)(a, ["props", "maxDate"]) && isnotnull(a.props.maxDate) ? {
    maxDate: (0, _formatting.formatOdooDate2Sys)(a.props.maxDate)
  } : {}, (0, _has2.default)(a, ["props", "minDate"]) && isnotnull(a.props.minDate) ? {
    minDate: (0, _formatting.formatOdooDate2Sys)(a.props.minDate),
    initialPickerDate: (0, _formatting.formatOdooDate2Sys)(a.props.minDate)
  } : {}));
}),
    timePattern = "^([01][0-9]|2[0-3]):[0-5][0-9]$",
    TimePicker = exports.TimePicker = function (a) {
  // const hourOptions = range(0, 24).map(key => ({ key, text: `` + key }));
  var b = (0, _react.useState)(a.value),
      c = (0, _slicedToArray3.default)(b, 2),
      d = c[0],
      f = c[1],
      g = (0, _react.useCallback)(function (a) {
    var b = a.target.value.trim().replace(/[^0-9:]/g, "").substr(0, 5);
    "23:59" >= b && "59" >= b.substr(3, 2) && f(b);
  }),
      h = (0, _react.useCallback)(function (a) {
    return (0, _validations.validateRE)(timePattern, a) ? "" : "Invalid Time for HH:MM";
  }, []);
  return _react2.default.createElement(_TextField.TextField, {
    style: {
      maxWidth: 80
    },
    title: "Enter Time in 24 hour format (HH:MM)",
    value: d,
    onChange: g,
    onBlur: function onBlur(b) {
      (0, _validations.validateRE)(timePattern, b.target.value) && a.onChange(b);
    },
    pattern: timePattern,
    placeholder: "__:__",
    onGetErrorMessage: h
  });
}; //const range = (s, e) => Array.from('x'.repeat(e - s), (_, i) => s + i);


function myTimeZone(a) {
  return /(\(.*\))/.exec(a.toString())[1];
}

var combineDateTime = function combineDateTime(a, b) {
  if (!a) return "";
  if (!b) return (0, _formatting.formatSys2OdooDatetime)(a);
  var c = parseInt(b.substring(0, 2)),
      d = parseInt(b.substring(3, 5)),
      e = a;
  return e.setHours(c), e.setMinutes(d), (0, _formatting.formatSys2OdooDatetime)(e);
},
    DateTimeField = exports.DateTimeField = _react2.default.memo(function (a) {
  (0, _has2.default)(a, ["props", "description"]) && (0, _set2.default)(a.props, ["textField", "description"], a.props.description);
  var b = (0, _formatting.formatOdooDatetime2Sys)(a.value),
      c = !a.value ? ["", "", ""] : [b, b.toTimeString().substring(0, 5), myTimeZone(b)],
      e = (0, _slicedToArray3.default)(c, 3),
      f = e[0],
      d = e[1],
      g = e[2],
      h = (0, _react.useCallback)(function (b) {
    return a.onFieldChange(combineDateTime(b, d, d));
  }, [d]),
      i = (0, _react.useCallback)(function (b) {
    return a.onFieldChange(combineDateTime(f, b.target.value));
  }, [f]);
  return _react2.default.createElement("div", {
    className: (0, _get2.default)("props", "props.className"),
    style: (0, _get2.default)(a, ["props", "styles", "root"])
  }, !!a.label && _react2.default.createElement(_Label.Label, null, a.label, " ", (0, _get2.default)(a, ["props", "required"]) && "*", _react2.default.createElement(_Text.Text, {
    variant: "small",
    style: {
      paddingLeft: 12,
      color: "grey"
    }
  }, g)), _react2.default.createElement(_Stack.Stack, {
    horizontal: !0,
    horizontalAlign: "start",
    tokens: {
      childrenGap: 6
    }
  }, _react2.default.createElement("div", {
    style: {
      maxWidth: 150
    }
  }, _react2.default.createElement(_DatePicker.DatePicker, (0, _extends3.default)({
    key: "g" + a.name.toString(),
    strings: DayPickerStrings,
    isRequired: !1
  }, a.props, {
    label: "",
    name: a.name,
    value: f,
    onSelectDate: h
  }, (0, _has2.default)(a, ["props", "pastDatesOnly"]) ? {
    maxDate: new Date()
  } : {}, (0, _has2.default)(a, ["props", "futureDatesOnly"]) ? {
    minDate: new Date()
  } : {}, (0, _has2.default)(a, ["props", "maxDate"]) && isnotnull(a.props.maxDate) ? {
    maxDate: (0, _formatting.formatOdooDate2Sys)(a.props.maxDate)
  } : {}, (0, _has2.default)(a, ["props", "minDate"]) && isnotnull(a.props.minDate) ? {
    minDate: (0, _formatting.formatOdooDate2Sys)(a.props.minDate),
    initialPickerDate: (0, _formatting.formatOdooDate2Sys)(a.props.minDate)
  } : {}))), _react2.default.createElement(TimePicker, {
    key: d ? d : "X",
    value: d,
    onChange: i
  })), (0, _has2.default)(a, ["props", "description"]) && _react2.default.createElement("div", {
    style: descStyle
  }, a.props.description));
}),
    RadioField = exports.RadioField = _react2.default.memo(function (a) {
  var b = a.name,
      c = a.onFieldChange,
      d = a.props,
      e = a.label,
      f = a.value,
      g = a.options,
      h = g.map(function (a) {
    return "string" == typeof a ? {
      key: a,
      text: a
    } : {
      key: a.name,
      text: (0, _get2.default)(a, "label", a.name)
    };
  });
  return _react2.default.createElement(_ChoiceGroup.ChoiceGroup, (0, _extends3.default)({
    key: "g" + b.toString(),
    required: !0
  }, d, {
    label: e,
    selectedKey: f,
    options: h,
    onChange: function d(a, b) {
      return c(b.key);
    }
  }));
}),
    RadioObjectField = exports.RadioObjectField = _react2.default.memo(function (a) {
  var b = a.name,
      c = a.onFieldChange,
      d = a.props,
      e = a.label,
      f = a.value,
      g = a.options,
      h = g.map(function (a) {
    return "string" == typeof a ? {
      key: a,
      text: a,
      data: {}
    } : {
      key: a.name,
      text: (0, _get2.default)(a, "label", a.name),
      data: (0, _get2.default)(a, "data", {})
    };
  });
  return _react2.default.createElement(_ChoiceGroup.ChoiceGroup, (0, _extends3.default)({
    key: "g" + b.toString(),
    required: !0
  }, d, {
    label: e,
    selectedKey: f,
    options: h,
    onChange: function d(a, b) {
      return c(b.key, b.data);
    }
  }));
}),
    SelectField = exports.SelectField = _react2.default.memo(function (a) {
  var b = function b(_b, c) {
    return a.onFieldChange(c.key);
  },
      c = a.options.map(function (a) {
    return "string" == typeof a ? {
      key: a,
      text: a
    } : {
      key: a.name,
      text: (0, _get2.default)(a, "label", a.name)
    };
  });

  return (0, _has2.default)(a, ["props", "description"]) ? _react2.default.createElement("div", {
    style: (0, _get2.default)(a, ["props", "styles", "root"]),
    key: "g" + a.name.toString()
  }, _react2.default.createElement(_Dropdown.Dropdown, (0, _extends3.default)({
    required: !0
  }, a.props, {
    label: a.label,
    selectedKey: a.value ? a.value : void 0,
    options: c,
    onChange: b
  })), _react2.default.createElement("div", {
    style: descStyle
  }, a.props.description)) : _react2.default.createElement(_Dropdown.Dropdown, (0, _extends3.default)({
    key: "g" + a.name.toString(),
    required: !0
  }, a.props, {
    label: a.label,
    selectedKey: a.value ? a.value : void 0,
    options: c,
    onChange: b
  }));
}),
    SelectObjectField = exports.SelectObjectField = _react2.default.memo(function (a) {
  var b = function b(_b2, c) {
    return a.onFieldChange(c.key, c.data);
  },
      c = a.options.map(function (a) {
    return "string" == typeof a ? {
      key: a,
      text: a,
      data: {}
    } : {
      key: a.name,
      text: (0, _get2.default)(a, "label", a.name),
      data: (0, _get2.default)(a, "data", {})
    };
  });

  return (0, _has2.default)(a, ["props", "description"]) ? _react2.default.createElement("div", {
    style: (0, _get2.default)(a, ["props", "styles", "root"]),
    key: "g" + a.name.toString()
  }, _react2.default.createElement(_Dropdown.Dropdown, (0, _extends3.default)({
    required: !0
  }, a.props, {
    label: a.label,
    selectedKey: a.value ? a.value : void 0,
    options: c,
    onChange: b
  })), _react2.default.createElement("div", {
    style: descStyle
  }, a.props.description)) : _react2.default.createElement(_Dropdown.Dropdown, (0, _extends3.default)({
    key: "g" + a.name.toString(),
    required: !0
  }, a.props, {
    label: a.label,
    selectedKey: a.value ? a.value : void 0,
    options: c,
    onChange: b
  }));
}),
    ComboField = exports.ComboField = _react2.default.memo(function (a) {
  var b = (0, _react.useCallback)(function (b, c) {
    return a.onFieldChange(c.key);
  }, []),
      c = (0, _react.useMemo)(function () {
    return a.options.map(function (a) {
      return "string" == typeof a ? {
        key: a,
        text: a
      } : {
        key: a.name,
        text: (0, _get2.default)(a, "label", a.name)
      };
    });
  }, [a.options]);
  return (0, _has2.default)(a, ["props", "description"]) ? _react2.default.createElement("div", {
    style: (0, _get2.default)(a, ["props", "styles", "root"]),
    key: "g" + a.name.toString()
  }, _react2.default.createElement(_ComboBox.ComboBox, (0, _extends3.default)({
    required: !0
  }, a.props, {
    label: a.label,
    selectedKey: a.value ? a.value : void 0,
    options: c,
    onChange: b
  })), _react2.default.createElement("div", {
    style: descStyle
  }, a.props.description)) : _react2.default.createElement(_ComboBox.ComboBox, (0, _extends3.default)({
    key: "g" + a.name.toString(),
    required: !0
  }, a.props, {
    label: a.label,
    selectedKey: a.value ? a.value : void 0,
    options: c,
    onChange: b
  }));
}),
    HtmlField = exports.HtmlField = _react2.default.memo(function (a) {
  return _react2.default.createElement("div", {
    className: (0, _get2.default)("props", "props.className"),
    style: (0, _get2.default)(a, ["props", "styles", "root"])
  }, !!a.label && _react2.default.createElement(_Label.Label, null, a.label, " ", (0, _get2.default)(a, ["props", "required"]) && "*"), (0, _get2.default)(a, "props.readOnly") ? _react2.default.createElement("div", {
    dangerouslySetInnerHTML: a.value,
    style: {
      border: "1px solid lightgrey",
      padding: "10"
    }
  }) : _react2.default.createElement(_RichEditor.RichEditor, (0, _extends3.default)({}, a.props, {
    value: a.value,
    setValue: a.onFieldChange
  })), (0, _has2.default)(a, ["props", "description"]) && _react2.default.createElement("div", {
    style: descStyle
  }, a.props.description));
});

function _convertValueToItems(a, b) {
  if (!b) return [];
  var c = (0, _keyBy2.default)(a, function (a) {
    return "" + a.key;
  }),
      d = void 0;
  return d = "string" != typeof b && Array.isArray(b) ? b : [b], d.map(function (a) {
    return (0, _get2.default)(c, "" + a, {
      key: a,
      name: a
    });
  });
}

var MultiAutoSuggest = exports.MultiAutoSuggest = _react2.default.memo(function (a) {
  var b = (0, _react.useMemo)(function () {
    return a.options.map(function (a) {
      return "string" == typeof a ? {
        key: a,
        name: a
      } : {
        key: a.name,
        name: (0, _get2.default)(a, "label", a.name)
      };
    });
  }, [a.options]),
      c = (0, _react.useCallback)(function (b) {
    return a.onFieldChange(b.map(function (a) {
      return a.key;
    }));
  }, []),
      d = (0, _react.useCallback)(function (a) {
    return a.name;
  }, []),
      e = (0, _react.useCallback)(function (a, c) {
    return a ? b.filter(function (b) {
      return 0 === b.name.toLowerCase().indexOf(a.toLowerCase().trim());
    }).filter(function (a) {
      return !f(a, c);
    }) : [];
  }, [b]),
      f = (0, _react.useCallback)(function (a, b) {
    return !!(b && b.length && 0 !== b.length) && b.some(function (b) {
      return b.name === a.name;
    });
  }, []),
      g = (0, _react.useMemo)(function () {
    return _convertValueToItems(b, a.value);
  }, [b, a.value]);
  return _react2.default.createElement("div", {
    className: (0, _get2.default)("props", "props.className"),
    style: (0, _get2.default)(a, ["props", "styles", "root"])
  }, !!a.label && _react2.default.createElement(_Label.Label, null, a.label, " ", (0, _get2.default)(a, ["props", "required"]) && "*"), _react2.default.createElement(_Pickers.TagPicker, (0, _extends3.default)({
    styles: {
      input: {
        backgroundColor: "white"
      }
    },
    removeButtonAriaLabel: "Remove"
  }, a.props, {
    onResolveSuggestions: e,
    getTextFromItem: d,
    pickerSuggestionsProps: {
      styles: {
        root: {
          backgroundColor: "yellow"
        }
      },
      suggestionsHeaderText: "Suggested " + a.label,
      noResultsFoundText: "--"
    },
    selectedItems: g,
    onChange: c
  })), (0, _has2.default)(a, ["props", "description"]) && _react2.default.createElement("div", {
    style: descStyle
  }, a.props.description));
}),
    AutoSuggest = exports.AutoSuggest = _react2.default.memo(function (a) {
  var b = (0, _uniqueId2.default)(),
      c = (0, _react.useState)([]),
      d = (0, _slicedToArray3.default)(c, 2),
      e = d[0],
      f = d[1],
      g = (0, _get2.default)(a, "props.remoteItemsApi"),
      h = (0, _get2.default)(a, "props.remoteKeyApi"),
      i = (0, _react.useMemo)(function () {
    return g ? e : a.options.map(function (a) {
      return "string" == typeof a ? {
        key: a,
        name: a
      } : {
        key: a.name,
        name: (0, _get2.default)(a, "label", a.name)
      };
    });
  }, [a.props, a.options, e]),
      j = (0, _react.useCallback)(function (b) {
    return a.onFieldChange((0, _get2.default)(b, [0, "key"], ""));
  }, []),
      k = (0, _react.useCallback)(function (a) {
    return a.name;
  }, []),
      l = (0, _react.useCallback)(function (a, c) {
    return a && g ? g(a, b).then(function (a) {
      return f(a), a;
    }) : a ? i.filter(function (b) {
      return 0 === b.name.toLowerCase().indexOf(a.toLowerCase().trim());
    }).filter(function (a) {
      return !m(a, c);
    }) : [];
  }, [i]),
      m = (0, _react.useCallback)(function (a, b) {
    return !!(b && b.length && 0 !== b.length) && b.some(function (b) {
      return b.name === a.name;
    });
  }, []),
      n = (0, _react.useMemo)(function () {
    return _convertValueToItems(i, a.value);
  }, [a.value, i]); //console.log( "Props.styles", get(props, ["props", "styles"]));

  return (0, _react.useEffect)(function () {
    !!h && a.value && h(a.value).then(f);
  }, []), _react2.default.createElement("div", {
    className: (0, _get2.default)(a, "props.className"),
    style: (0, _get2.default)(a, ["props", "styles", "root"])
  }, !!a.label && _react2.default.createElement(_Label.Label, null, a.label, " ", (0, _get2.default)(a, "props.required") && "*"), _react2.default.createElement(_Pickers.TagPicker, (0, _extends3.default)({
    styles: {
      root: {
        backgroundColor: "white"
      }
    },
    removeButtonAriaLabel: "Remove"
  }, (0, _get2.default)(a, "props"), {
    onResolveSuggestions: l,
    getTextFromItem: k,
    pickerSuggestionsProps: {
      styles: {
        root: {
          backgroundColor: "yellow"
        }
      },
      suggestionsHeaderText: "Suggested " + a.label,
      noResultsFoundText: "--"
    },
    itemLimit: 1,
    selectedItems: n,
    onChange: j
  })), (0, _has2.default)(a, ["props", "description"]) && _react2.default.createElement("div", {
    style: descStyle
  }, a.props.description));
}),
    AutoSuggestObject = exports.AutoSuggestObject = _react2.default.memo(function (a) {
  var b = (0, _react.useMemo)(function () {
    return a.options.map(function (a) {
      return "string" == typeof a ? {
        key: a,
        name: a,
        data: {}
      } : {
        key: a.name,
        name: (0, _get2.default)(a, "label", a.name),
        data: (0, _get2.default)(a, "data", {})
      };
    });
  }, [a.options]),
      c = (0, _react.useCallback)(function (b) {
    a.onFieldChange((0, _get2.default)(b, [0, "key"], ""), (0, _get2.default)(b, [0, "data"], {}));
  }, []),
      d = (0, _react.useCallback)(function (a) {
    return a.name;
  }, []),
      e = (0, _react.useCallback)(function (a, c) {
    return a ? b.filter(function (b) {
      return 0 === b.name.toLowerCase().indexOf(a.toLowerCase().trim());
    }).filter(function (a) {
      return !f(a, c);
    }) : [];
  }, [b]),
      f = (0, _react.useCallback)(function (a, b) {
    return !!(b && b.length && 0 !== b.length) && b.some(function (b) {
      return b.name === a.name;
    });
  }, []),
      g = (0, _react.useMemo)(function () {
    return _convertValueToItems(b, a.value);
  }, [b, a.value]); //console.log("Props.styles", get(props, ["props", "styles"]));

  return _react2.default.createElement("div", {
    className: (0, _get2.default)(a, "props.className"),
    style: (0, _get2.default)(a, ["props", "styles", "root"])
  }, !!a.label && _react2.default.createElement(_Label.Label, null, a.label, " ", (0, _get2.default)(a, ["props", "required"]) && "*"), _react2.default.createElement(_Pickers.TagPicker, (0, _extends3.default)({
    styles: {
      input: {
        backgroundColor: "white"
      }
    },
    removeButtonAriaLabel: "Remove"
  }, a.props, {
    onResolveSuggestions: e,
    getTextFromItem: d,
    pickerSuggestionsProps: {
      styles: {
        root: {
          backgroundColor: "yellow"
        }
      },
      suggestionsHeaderText: "Suggested " + a.label,
      noResultsFoundText: "--"
    },
    itemLimit: 1,
    selectedItems: g,
    onChange: c
  })), (0, _has2.default)(a, ["props", "description"]) && _react2.default.createElement("div", {
    style: descStyle
  }, a.props.description));
}),
    MultiSelect = exports.MultiSelect = _react2.default.memo(function (a) {
  var b = function b(_b3, c) {
    return a.onFieldChange(c.key);
  },
      c = a.options.map(function (a) {
    return "string" == typeof a ? {
      key: a,
      text: a
    } : {
      key: a.name,
      text: (0, _get2.default)(a, "label", a.name)
    };
  });

  return (0, _has2.default)(a, ["props", "description"]) ? _react2.default.createElement("div", {
    style: (0, _get2.default)(a, ["props", "styles", "root"]),
    key: "g" + a.name.toString()
  }, _react2.default.createElement(_Dropdown.Dropdown, (0, _extends3.default)({
    required: !0
  }, a.props, {
    label: a.label,
    multiSelect: !0,
    selectedKeys: a.value ? a.value : void 0,
    options: c,
    onChange: b
  })), _react2.default.createElement("div", {
    style: descStyle
  }, a.props.description)) : _react2.default.createElement(_Dropdown.Dropdown, (0, _extends3.default)({
    key: "g" + a.name.toString(),
    required: !0
  }, a.props, {
    label: a.label,
    multiSelect: !0,
    selectedKeys: a.value ? a.value : void 0,
    options: c,
    onChange: b
  }));
}),
    CheckBoxField = exports.CheckBoxField = _react2.default.memo(function (a) {
  var b = function b(_b4, c) {
    return a.onFieldChange(c);
  };

  return (0, _has2.default)(a, ["props", "description"]) ? _react2.default.createElement("div", {
    style: (0, _get2.default)(a, ["props", "styles", "root"]),
    key: "g" + a.name.toString()
  }, _react2.default.createElement(_Checkbox.Checkbox, (0, _extends3.default)({}, a.props, {
    label: a.label,
    checked: a.value,
    onChange: b
  })), _react2.default.createElement("div", {
    style: descStyle
  }, a.props.description)) : _react2.default.createElement(_Checkbox.Checkbox, (0, _extends3.default)({
    key: "g" + a.name.toString()
  }, a.props, {
    label: a.label,
    checked: a.value,
    onChange: b
  }));
}),
    MultiCheckBoxField = exports.MultiCheckBoxField = _react2.default.memo(function (a) {
  //console.log(props);
  var b = a.options.map(function (a) {
    return "string" == typeof a ? {
      name: a,
      label: a
    } : {
      name: a,
      label: (0, _get2.default)(a, "label", a.name)
    };
  });
  return _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement(_Label.Label, null, a.label), (0, _get2.default)(a, "props.btnSelectAll", !1) && _react2.default.createElement(_Link.Link, {
    style: {
      marginRight: 12
    },
    onClick: function c() {
      a.onFieldChange(b.map(function (a) {
        return a.name;
      }), "single");
    }
  }, _react2.default.createElement("small", null, _react2.default.createElement(_Icon.Icon, {
    iconName: "Accept"
  }), " Select All")), (0, _get2.default)(a, "props.btnSelectNone", !1) && _react2.default.createElement(_Link.Link, {
    onClick: function b() {
      a.onFieldChange([], "single");
    }
  }, _react2.default.createElement("small", null, _react2.default.createElement(_Icon.Icon, {
    iconName: "Cancel"
  }), " Select None")), b.map(function (b, c) {
    return _react2.default.createElement(_Checkbox.Checkbox, (0, _extends3.default)({
      key: "go" + a.name.toString() + c
    }, a.props, {
      label: b.label,
      checked: a.value.includes(b.name),
      onChange: function c() {
        return a.onFieldChange(b.name);
      }
    }));
  }), (0, _has2.default)(a, ["props", "description"]) && _react2.default.createElement("div", {
    style: descStyle
  }, a.props.description));
}),
    ToggleField = exports.ToggleField = _react2.default.memo(function (a) {
  var b = function b(_b5, c) {
    return a.onFieldChange(c);
  };

  return (0, _has2.default)(a, ["props", "description"]) ? _react2.default.createElement("div", {
    style: (0, _get2.default)(a, ["props", "styles", "root"]),
    key: "g" + a.name.toString()
  }, _react2.default.createElement(_Toggle.Toggle, (0, _extends3.default)({
    onText: "Yes",
    offText: "No"
  }, a.props, {
    label: a.label,
    checked: a.value,
    onChange: b
  })), _react2.default.createElement("div", {
    style: descStyle
  }, a.props.description)) : _react2.default.createElement(_Toggle.Toggle, (0, _extends3.default)({
    key: "g" + a.name.toString(),
    onText: "Yes",
    offText: "No"
  }, a.props, {
    label: a.label,
    checked: a.value,
    onChange: b
  }));
}),
    FirebaseFileInput = exports.FirebaseFileInput = _react2.default.memo(function (a) {
  //console.log(props);
  var b = a.props,
      c = b.firebaseStorage,
      d = b.namespace,
      e = b.config,
      f = e === void 0 ? {} : e,
      g = b.inputProps,
      h = g === void 0 ? {} : g,
      i = b.readOnly,
      j = i !== void 0 && i,
      k = b.hideSubmit,
      l = k !== void 0 && k;
  if (!c || !d) throw alert("Firebase Configuration / namespace Invalid"), "Firebase Configuration / namespace Invalid";
  var m = null;

  try {
    m = JSON.parse(a.value);
  } catch (a) {}

  return _react2.default.createElement("div", {
    style: (0, _get2.default)(a, ["props", "styles", "root"]),
    key: "g" + a.name.toString()
  }, !!a.label && _react2.default.createElement(_Label.Label, null, a.label, " ", (0, _get2.default)(a, ["props", "required"]) && "*"), !!m && (j || l) ? _react2.default.createElement("a", {
    href: m.downloadURL,
    target: "_blank",
    key: m.downloadURL
  }, "contentType" in m && m.contentType.startsWith("image") && _react2.default.createElement(_Image.Image, {
    src: m.downloadURL,
    width: 200,
    alt: "Loading..."
  }), m.fileName) : _react2.default.createElement(_fileinput.MyFileInput, {
    file: a.value,
    setFile: a.onFieldChange,
    readOnly: j || l,
    firebaseStorage: c,
    namespace: d,
    config: f,
    inputProps: h
  }), (0, _has2.default)(a, ["props", "description"]) && _react2.default.createElement("div", {
    style: descStyle
  }, a.props.description));
}),
    SubmitButton = exports.SubmitButton = function () {
  return _react2.default.createElement(_Button.DefaultButton, {
    type: "submit",
    primary: !0
  }, "Save");
},
    DiscardButton = exports.DiscardButton = function () {
  return _react2.default.createElement(_Button.DefaultButton, null, "Discard");
},
    AddButton = exports.AddButton = function () {
  return _react2.default.createElement(_Button.IconButton, {
    iconProps: {
      iconName: "Add"
    }
  });
},
    DeleteButton = exports.DeleteButton = function () {
  return _react2.default.createElement(_Button.IconButton, {
    iconProps: {
      iconName: "Delete"
    }
  });
},
    Errors = exports.Errors = function (a) {
  var b = a.text;
  return b && _react2.default.createElement(_MessageBar.MessageBar, {
    messageBarType: _MessageBar.MessageBarType.error
  }, _react2.default.createElement("div", null, _react2.default.createElement("b", null, "Form Error: ")), _react2.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: b.toString()
    }
  }));
},
    Loading = exports.Loading = function () {
  return _react2.default.createElement(_Spinner.Spinner, {
    label: "...",
    ariaLive: "assertive",
    labelPosition: "right",
    size: _Spinner.SpinnerSize.large
  });
},
    ListField = exports.ListField = function (a) {
  function b() {
    j.push(""), f.setKV(j, h, "single");
  }

  function c(a) {
    j.splice(a, 1), f.setKV(j, h, "single");
  }

  var d = a.kidx,
      e = a.type,
      f = a.params,
      g = a.inlineForm,
      h = f.name,
      i = f.value,
      j = [];
  return j = Array.isArray(i) ? [].concat((0, _toConsumableArray3.default)(i)) : [], _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement(_Label.Label, null, f.label), j.map(function (a, b) {
    return _react2.default.createElement(_Stack.Stack, {
      horizontal: !0,
      horizontalAlign: "start"
    }, fieldSwitcher(d + "v" + b, e, (0, _extends3.default)({}, f, {
      label: "",
      name: h + "[" + b + "]",
      value: a,
      setKV: function d(a, b, c) {
        return f.setKV(a, "" + b, c);
      }
    }), g), _react2.default.createElement(_Button.IconButton, {
      iconProps: {
        iconName: "Cancel"
      },
      onClick: function a() {
        return c(b);
      }
    }));
  }), _react2.default.createElement(_Button.IconButton, {
    iconProps: {
      iconName: "Add"
    },
    onClick: b
  }));
},
    initial = "a",
    emptyDict = {},
    useOptions = function useOptions(a) {
  var b = (0, _react.useState)((0, _get2.default)(a, "options", [])),
      c = (0, _slicedToArray3.default)(b, 2),
      d = c[0],
      e = c[1],
      f = (0, _react.useState)(initial),
      g = (0, _slicedToArray3.default)(f, 2),
      h = g[0],
      i = g[1],
      j = (0, _get2.default)(a, ["props", "promiseParams"], emptyDict);
  return (0, _react.useEffect)(function () {
    if ((0, _has2.default)(a, ["optionsPromise", "promise"])) {
      var b = (0, _stringify2.default)(j);
      h !== b && a.optionsPromise.promise(j).then(function (c) {
        h !== initial && (0, _has2.default)(a, "onFieldChange") && a.onFieldChange(""), e(c), i(b);
      }).catch(function () {
        return e((0, _get2.default)(a, "options", []));
      });
    }
  }, [j]), (0, _has2.default)(a, ["optionsPromise", "promise"]) ? (0, _extends3.default)({}, a, {
    key: h,
    options: d
  }) : a;
},
    FieldSwitch = function FieldSwitch(a) {
  var b = a.params,
      c = a.type,
      d = a.inlineForm,
      e = useOptions(b);
  return "radio" === c ? d ? _react2.default.createElement(SelectField, e) : _react2.default.createElement(RadioField, e) : "radio_object" === c ? d ? _react2.default.createElement(SelectObjectField, e) : _react2.default.createElement(RadioObjectField, e) : "select" === c ? _react2.default.createElement(SelectField, e) : "select_object" === c ? _react2.default.createElement(SelectObjectField, e) : "comboxbox" === c ? _react2.default.createElement(ComboField, e) : "autosuggest" === c ? _react2.default.createElement(AutoSuggest, e) : "autosuggest_object" === c ? _react2.default.createElement(AutoSuggestObject, e) : "multiautosuggest" === c ? _react2.default.createElement(MultiAutoSuggest, e) : "multiselect" === c ? _react2.default.createElement(MultiSelect, e) : "checkbox" === c ? _react2.default.createElement(CheckBoxField, e) : "multicheckbox" === c ? _react2.default.createElement(MultiCheckBoxField, e) : "toggle" === c ? _react2.default.createElement(ToggleField, e) : "date" === c ? _react2.default.createElement(DateField, e) : "datetimetz" === c ? _react2.default.createElement(DateTimeField, e) : "firebasefile" === c ? _react2.default.createElement(FirebaseFileInput, e) : "jsonkv" === c ? _react2.default.createElement(JsonKV, e) : "statichtml" === c ? _react2.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: e.label
    }
  }) : "htmlfield" === c ? _react2.default.createElement(HtmlField, e) : _react2.default.createElement(InputField, e);
};

function fieldSwitcher(a, b, c) {
  var d = !!(3 < arguments.length && arguments[3] !== void 0) && arguments[3],
      e = !!(4 < arguments.length && arguments[4] !== void 0) && arguments[4];
  if (e) return _react2.default.createElement(ListField, {
    kidx: a,
    type: b,
    params: c,
    inlineForm: d
  });
  var f = "k" + a + c.name.toString();
  if ((0, _get2.default)(c, ["props", "readOnly"], !1)) return _react2.default.createElement(InputField, (0, _extends3.default)({}, c, {
    required: !1,
    readOnly: !0,
    borderless: !0,
    key: f,
    type: "text",
    value: (0, _.printField)(b, c.value, c.options)
  }));
  if ((0, _get2.default)(c, ["props", "displayOnly"], !1)) return _react2.default.createElement("div", {
    style: {
      marginTop: "4px"
    }
  }, !!c.label && _react2.default.createElement(_Label.Label, null, c.label), (0, _.printField)(b, c.value, c.options));

  var g = function g(a) {
    var d = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : void 0; //console.log(v, params1.name, (vtype ? vtype : ((type === "multiselect" || type === "multicheckbox") ? "multiple" : "single")));

    c.setKV(a, c.name, d ? d : "multiselect" === b || "multicheckbox" === b ? "multiple" : "single");
  };

  ["radio_object", "select_object", "autosuggest_object"].includes(b) && (g = function g(a) {
    var b = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {};
    void 0, c.setKV(a, c.name, "single");
    var d = (0, _get2.default)(c, ["props", "data_keys"]);
    void 0, "object" === ("undefined" == typeof d ? "undefined" : (0, _typeof3.default)(d)) && (0, _entries2.default)(d).map(function (a) {
      var d = (0, _slicedToArray3.default)(a, 2),
          e = d[0],
          f = d[1],
          g = (0, _slicedToArray3.default)(f, 2),
          h = g[0],
          i = g[1],
          j = void 0;
      Array.isArray(c.name) ? (j = [].concat((0, _toConsumableArray3.default)(c.name)), j[j.length - 1] = e) : j = e, void 0, c.setKV((0, _get2.default)(b, h, i), j, "single");
    });
  });
  var h = (0, _extends3.default)({}, c, {
    onFieldChange: g
  });
  return _react2.default.createElement(FieldSwitch, {
    params: h,
    key: "a" + f,
    keyname: f,
    type: b,
    inlineForm: d
  });
}